import {
  GET_SURVEY_TOKENS,
  DELETE_SURVEY_TOKEN,
  CLEAR_SURVEY_TOKEN,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  survey_tokens: [],
  pending: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_SURVEY_TOKENS:
      return {
        ...state,
        survey_tokens: action.payload,
        pending: false,
      };

    case DELETE_SURVEY_TOKEN:
      return {
        ...state,
        payments: state.survey_tokens.filter(
          (row) => row.id !== action.payload
        ),
      };

    case CLEAR_SURVEY_TOKEN:
      return {
        ...state,
        survey_tokens: [],
        pending: false,
      };
    case CLEAR_ALL:
      return {
        ...state,
        survey_tokens: [],
        pending: false,
      };
    default:
      return state;
  }
}
